import { Label } from '@honda-canada/design-system-react';
import React from 'react';
import themeStyles from './SignupForUpdates.styles';
var StyledErrorLabel = themeStyles.apply(Label, 'StyledErrorLabel');
var CustomErrorLabel = function (_a) {
    var children = _a.children, _b = _a.testId, testId = _b === void 0 ? '' : _b;
    return (React.createElement(StyledErrorLabel, { "data-testid": testId, hasError: true }, children));
};
export default CustomErrorLabel;
